import { render, staticRenderFns } from "./Bell.vue?vue&type=template&id=67c397d0&scoped=true&ref=bell"
import script from "./Bell.vue?vue&type=script&lang=js"
export * from "./Bell.vue?vue&type=script&lang=js"
import style0 from "./Bell.vue?vue&type=style&index=0&id=67c397d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c397d0",
  null
  
)

export default component.exports